/* eslint-disable max-lines */
import { PictureTransformations } from 'common/components';
import { FencesMainPageType } from '../../fences-types';

export type FencesGalleryStructure = {
  alt: string;
  addText?: string;
  name: string;
  src: string;
  srcSmall: string;
  transformations?: PictureTransformations;
};

type FencesImageNameStructure = {
  name: string;
  subFolder?: 'without-panel-modul-zhalyuzi' | 'without-panel-modul' | 'with-all';
};

const FENCES_MAIN_PAGE_WITHOUT_PANEL_MODUL_ZHALYUZI_IMAGE_NAME_LIST: FencesImageNameStructure[] = [
  {
    name: 'Профнастил фигурный',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Профнастил фигурный',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul-zhalyuzi',
  },
];

const FENCES_MAIN_PAGE_WITHOUT_PANEL_MODUL_IMAGE_NAME_LIST: FencesImageNameStructure[] = [
  {
    name: 'Профнастил фигурный',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Заборы-жалюзи',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Заборы-жалюзи',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Профнастил фигурный',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Заборы-жалюзи',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Профнастил',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'without-panel-modul',
  },
];

const FENCES_MAIN_PAGE_WITH_ALL_IMAGE_NAME_LIST: FencesImageNameStructure[] = [
  {
    name: 'Профнастил фигурный',
    subFolder: 'with-all',
  },
  {
    name: 'Профнастил',
    subFolder: 'with-all',
  },
  {
    name: 'Модульное ограждение',
    subFolder: 'with-all',
  },
  {
    name: 'Заборы-жалюзи',
    subFolder: 'with-all',
  },
  {
    name: 'Панельное ограждение',
    subFolder: 'with-all',
  },
  {
    name: 'Профнастил',
    subFolder: 'with-all',
  },
  {
    name: 'Модульное ограждение',
    subFolder: 'with-all',
  },
  {
    name: 'Панельные ограждения',
    subFolder: 'with-all',
  },
  {
    name: 'Заборы-жалюзи',
    subFolder: 'with-all',
  },
  {
    name: 'Профнастил',
    subFolder: 'with-all',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'with-all',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'with-all',
  },
  {
    name: 'Модульное ограждение',
    subFolder: 'with-all',
  },
  {
    name: 'Панельное ограждение',
    subFolder: 'with-all',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'with-all',
  },
  {
    name: 'Заборы-жалюзи',
    subFolder: 'with-all',
  },
  {
    name: 'Профнастил фигурный',
    subFolder: 'with-all',
  },
  {
    name: 'Модульное ограждение',
    subFolder: 'with-all',
  },
  {
    name: 'Панельное ограждение',
    subFolder: 'with-all',
  },
  {
    name: 'Металлический штакетник',
    subFolder: 'with-all',
  },
];

const FENCES_PROFNASTIL_IMAGE_NAME_LIST: FencesImageNameStructure[] = [
  {
    name: 'Профнастил фигурный',
  },
  {
    name: 'Профнастил',
  },
  {
    name: 'Профнастил',
  },
  {
    name: 'Профнастил',
  },
  {
    name: 'Профнастил фигурный',
  },
  {
    name: 'Профнастил',
  },
  {
    name: 'Профнастил',
  },
];

const FENCES_SHTAKETNIK_IMAGE_NAME_LIST: FencesImageNameStructure[] = [
  {
    name: 'Металлический штакетник',
  },
  {
    name: 'Металлический штакетник',
  },
  {
    name: 'Металлический штакетник',
  },
  {
    name: 'Металлический штакетник',
  },
  {
    name: 'Металлический штакетник',
  },
  {
    name: 'Металлический штакетник',
  },
  {
    name: 'Металлический штакетник',
  },
];

const FENCES_MODULNYE_OGRAZHDENIYA_IMAGE_NAME_LIST: FencesImageNameStructure[] = [
  {
    name: 'Модульное ограждение',
  },
  {
    name: 'Модульное ограждение',
  },
  {
    name: 'Модульное ограждение',
  },
  {
    name: 'Модульное ограждение',
  },
  {
    name: 'Модульное ограждение',
  },
];

const FENCES_PANELNYE_OGRAZHDENIYA_IMAGE_NAME_LIST: FencesImageNameStructure[] = [
  {
    name: 'Панельное ограждение',
  },
  {
    name: 'Панельное ограждение',
  },
  {
    name: 'Панельное ограждение',
  },
  {
    name: 'Панельное ограждение',
  },
  {
    name: 'Панельное ограждение',
  },
];

const FENCES_ZHALYUZI_IMAGE_NAME_LIST: FencesImageNameStructure[] = [
  {
    name: 'Заборы-жалюзи',
  },
  {
    name: 'Заборы-жалюзи',
  },
  {
    name: 'Заборы-жалюзи',
  },
];

export const FENCES_MAIN_PAGE_IMAGE_LIST_MAP: Record<FencesMainPageType, FencesImageNameStructure[]> = {
  withoutPanelModulZhalyuzi: FENCES_MAIN_PAGE_WITHOUT_PANEL_MODUL_ZHALYUZI_IMAGE_NAME_LIST,
  withoutPanelModul: FENCES_MAIN_PAGE_WITHOUT_PANEL_MODUL_IMAGE_NAME_LIST,
  withAll: FENCES_MAIN_PAGE_WITH_ALL_IMAGE_NAME_LIST,
};

export const FENCES_TYPES_IMAGE_LIST_MAP: Record<string, FencesImageNameStructure[]> = {
  'zabory-iz-profnastila': FENCES_PROFNASTIL_IMAGE_NAME_LIST,
  'metallicheskiy-shtaketnik': FENCES_SHTAKETNIK_IMAGE_NAME_LIST,
  'modulnye-ograzhdeniya': FENCES_MODULNYE_OGRAZHDENIYA_IMAGE_NAME_LIST,
  'panelnye-ograzhdeniya': FENCES_PANELNYE_OGRAZHDENIYA_IMAGE_NAME_LIST,
  'zabory-zhalyuzi': FENCES_ZHALYUZI_IMAGE_NAME_LIST,
};
